module.exports = __webpack_public_path__ + "img/img-magic-4-b-04-img-02.3ca3cac0.png";